import React from 'react';
import classNames from 'classnames';
import { Checkbox } from 'components';

import './tree-select-all-switch.scss';

interface Props {
	selectAllText?: string;
	onSelectAll: (value: boolean) => void;
	checked: boolean;
	indeterminate: boolean;
}

export const SELECT_ALL_TEXT = 'Select All';

const TreeSelectAllSwitch = ({ selectAllText = SELECT_ALL_TEXT, onSelectAll, checked, indeterminate }: Props) => {
	const selected = checked || indeterminate;

	return (
		<div
			className={classNames('tree-select-all-switch', {
				'all-selected': selected
			})}
			data-test-id="tree-select-all-switch"
		>
			<Checkbox onChange={() => onSelectAll(!checked)} checked={checked} indeterminate={indeterminate} />
			<span className="tree-select-all-switch-content" onClick={() => onSelectAll(!checked)}>
				{selectAllText}
			</span>
		</div>
	);
};

export default TreeSelectAllSwitch;
